'use client';

import React from 'react';

const Error = () => (
  <div
    className={
      'flex items-center justify-center w-full min-h-[400px] p-6 text-center'
    }
  >
    <div className={'space-y-2'}>
      <h1 className={'text-3xl font-bold'}>{'Oops!'}</h1>
      <p className={'text-sm text-gray-500'}>{'500 Internal Server Error'}</p>
    </div>
  </div>
);

export default Error;
